module.exports = __webpack_public_path__ + "img/GE.0b72ed9c.png";